import React, { useCallback, useEffect, useState, useMemo } from "react";
import { downloadBulkResult, bulkCancel, checkProductVariantCount, ResumePendingImports, bulkPolling, DeleteLogs, filterProductList, getProductImportHistory, getShopUrl, productExpportStatus, getStoreConfig, AddStoreConfig, MainAuthUrl, getExportConfig, fetchScheduleCounts, getPlanStatus, checkFeatureAccess, handlePlanError, ChargeUrl, getTrialStatus } from '../Services/CommonServices';
import { validateTagSeparator } from '../Validation/regex';
import { saveAs } from 'file-saver';
import { environment } from '../Services/environment';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { errorMetaModal, errorModal, WarningModal } from '../common/ErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import "../../custom.css"
import CSVMapping from './CSVMapping';
import ExportStatusCard from '../common/ExportStatusCard';
import { useNavigate } from 'react-router-dom';
import TabsFitted from '../common/FittedTabs';
import CronSchedulerConfig from '../common/CronSchedulerConfig';
import { getTimeDifferenceText } from '../common/FormatTimeDuration';
import { timezoneOptions } from '../common/TimezoneOptions';
import XmlIcon from '../../assets/xml.png';
import SheetsIcon from '../../assets/sheets.png';
import ftpIcon from '../../assets/ftp.png';
import WatermarkImage from '../../assets/3129492.jpg';
import FTPConnection from './Connections/FTPConnection';
import Presets from '../common/Presets';
import XMLConnection from './Connections/XMLConnection';
import SheetsConnection from './Connections/SheetsConnection';
import { emptyStateMarkup } from '../common/StateMarkup';
import DeleteModal from '../common/DeleteModal';
import { IntegrationCard } from '../common/IntegrationCard';
import BackupsList from './productBackup/BackupsList';
import UpgradeBanner from '../common/UpgradeBanner';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
const endpoint = environment.serverUrl;
const CHUNK_SIZE = 1048576; // 1MB
const PAGE_SIZE = 10;
export default function Products({ blockUpload, eventSource, appUpdate }) {
     const tabs = [
    { id: 0, label: 'Products' },
    { id: 1, label: 'Scheduled Integrations' },
    { id: 2, label: 'Backups & Restores' }
  ];
    const navigate = useNavigate();
    const queryString = window.location.search;
    const storeUrl = getShopUrl();
    const [ftpConfig, setFtpConfig] = useState({
        name: '',
        host: '',
        username: '',
        password: '',
        filePath: '',
        isSuccess: false
    });
    const [selectedIntegration, setSelectedIntegration] = useState('');
    const [createIntegrationPopover, setCreateIntegrationPopover] = useState(false);
    const [showIntegrationModal, setShowIntegrationModal] = useState(false);
    const [integrationModalType, setIntegrationModalType] = useState('');
    const [integrationConfig, setIntegrationConfig] = useState({
        jobName: '',
        cronExpression: '00 00 * * *',
        xmlUrl: '',
        ftpConfig: null,
        templateId: null,
        timeZone: timezoneOptions[0]?.value || 'UTC',
        ImportFormat: selectedIntegration
    });
    const [savedConfigs, setSavedConfigs] = useState([]);
    const [completedSteps, setCompletedSteps] = useState({ step1: false, step2: false });
    const [XMLUrl, setXMLUrl] = useState('');
    const [xmlFields, setXmlFields] = useState([]);
    const [shopifyFields, setShopifyFields] = useState([]);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [existingXmlConfig, setExistingXmlConfig] = useState([]);
    const [xmlConfigAction, setXmlConfigAction] = useState("create");
    const [jobId, setJobId] = useState(null);
    const [selectedTemplateId, setSelectedTemplateId] = useState("0");
    const [schedulerLoading, setSchedulerLoading] = useState(false);
    const [enableScheduler, setEnableScheduler] = useState(false);
    const [selectedSchedulerTab, setSchedulerSelectedTab] = useState(0);
    const [integrationUpgradeNotification, setIntegrationUpgradeNotification] = useState(null);
    const [urlError, setUrlError] = useState('');
    const [schedulerConfigCounts, setSchedulerConfigCounts] = useState({
        xmlCount: 0,
        ftpCount: 0,
        sheetsCount: 0
    });
    const [allIntegrationConfigs, setAllIntegrationConfigs] = useState([]);
    const [integrationPageNo, setIntegrationPageNo] = useState(1);
    const [integrationPageCount, setIntegrationPageCount] = useState(0);
    const [integrationPrvButton, setIntegrationPrvButton] = useState(true);
    const [integrationNxtButton, setIntegrationNxtButton] = useState(true);
    const exportFilterOptions = useMemo(() => [
        { label: 'Products', value: 'Products' },
        { label: 'Variants', value: 'Variants' },
        { label: 'Product Images', value: 'Product_images' },
        { label: 'Variant Images', value: 'Variant_images' },
        { label: 'Product Metafields', value: 'ProductMetafields' },
        { label: 'Variant Metafields', value: 'VariantMetafields' },
    ], []);
    const [selectedExportFilters, setSelectedExportFilters] = useState([]);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [openMapModal, setOpenMapModal] = useState(false);
    const [checkedExportFormat, setCheckedExportFormat] = useState(0);
    const [productCount, setProductCount] = useState(0);
    const [exportStatus, setExportStatus] = useState("");
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportCompletedAt, setExportCompletedAt] = useState('');
    const [exportResult, setExportResult] = useState({});
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [mutationType, setMutationType] = useState('');
    const [exportFilterMsg, setExportFilterMsg] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [types, setTypes] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState("All");
    const [selectedType, setSelectedType] = useState("All");
    const [selectedSearch, setSelectedSearch] = useState(null);
    const [exportNotifyJson, setExportNotifyJson] = useState(null);
    let isExportConfig = false;
    const [file, setFile] = useState();
    const [dropzoneKey, setDropzoneKey] = useState(0); // Key to force dropzone re-render
    const [csvHeaders, setCSVHeaders] = useState([]);
    const [incomingShopifyHeaders, setShopifyHeaders] = useState([]);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [metaDeleteResult, setMetaDeleteResult] = useState(null);
    const [productDeleteResult, setProductDeleteResult] = useState(null);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const [uploadWarnings, setUploadWarnings] = useState([]);
    const [processingMsg, setProcessingMsg] = useState('');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [productDeleteStatus, setProductDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitProducts, setSplitProducts] = useState();
    const [queryProducts, setQueryProducts] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [mappingSSE, setMappingSSE] = useState();
    const [fileParse, setFileParse] = useState();
    const [bulkCancelStatus, setBulkCancelStatus] = useState("");
    const [processingProgress, setProcessingProgress] = useState(0);
    const [backupStatus, setBackupStatus] = useState(null);
    const [backupProgress, setBackupProgress] = useState(null);
    const [currentOperationId, setCurrentOperationId] = useState(null);
    const [logs, setLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(false);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [pageNo, setPageNo] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [loadingMap, setLoadingMap] = useState({});
    const [active, setActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const [bulkErrorActive, setBulkErrorActive] = useState(false);
    const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
    const [uploadWarningsActive, setUploadWarningsActive] = useState(false);
    const [openPresetModal, setOpenPresetModal] = useState(false);
    const [deleteModalActive, setDeleteModalActive] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [showBanner, setShowBanner] = useState(false);
    const [toast, setToast] = useState(false);
    const [uploadErrorToat, setUploadErrorToat] = useState(false);
    const [metaInfoToast, setMetaInfoToast] = useState(false);
    const [tagSeparator, setTagSeparator] = useState(null);
    const [tagSeparatorValid, setTagSeparatorValid] = useState(true);
    const [conversionPrice, setConversionPrice] = useState(null);
    const [imageProxy, setImageProxy] = useState(false);
    const [appUpdateLoader, setAppUpdateLoader] = useState(false);
    const [planInfo, setPlanInfo] = useState({
        hasProPlan: false,
        isFreePlan: true,
        productCount: 0,
        productLimit: 100,
        features: {}
    });
    const [showUpgradeBanner, setShowUpgradeBanner] = useState(false);
    const [upgradeBannerMessage, setUpgradeBannerMessage] = useState('');
    const [restrictedFeature, setRestrictedFeature] = useState('');
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);
    const validFileTypes = ['.csv', '.xlsx'];
    const allSelected = useMemo(
        () => exportFilterOptions.every((option) => selectedExportFilters.includes(option.value)),
        [selectedExportFilters, exportFilterOptions]
    );

    const handleSelectAllChange = useCallback((checked) => {
        if (checked) {
            setSelectedExportFilters(exportFilterOptions.map((option) => option.value));
        } else {
            setSelectedExportFilters([]);
        }
    }, [exportFilterOptions]);

    const handleExportFilterChange = useCallback((value, checked) => {
        setSelectedExportFilters((prevSelectedFilters) => {
            if (checked) {
                return prevSelectedFilters.includes(value) ? prevSelectedFilters : [...prevSelectedFilters, value];
            }
            return prevSelectedFilters.filter((filter) => filter !== value);
        });
    }, []);
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setFile(acceptedFiles[0]);
            setSelectedIntegration(''); // Reset integration type for regular file upload
        },
        [],
    );
    const handleIntegrationSelect = useCallback((type) => {
        setSelectedIntegration(type);
        setEnableScheduler(false);
        setUrlError('');
    }, []);
    const handleChangeModal = useCallback(() => { 
        if (!active) { 
            getProductFilterList(); 
        } 
        setActive(!active); 
    }, [active]);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
    const handleUploadWarningsChangeModal = useCallback(() => setUploadWarningsActive(!uploadWarningsActive), [uploadWarningsActive]);
    const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const toggleUploadErrorToast = useCallback(() => setUploadErrorToat((toast) => !toast), []);
    const toggleMetaInfoToast = useCallback(() => setMetaInfoToast((toast) => !toast), []);
    const handleSchedulerTabChange = useCallback((selectedIndex) => { 
        setSchedulerSelectedTab(selectedIndex); 
        if (selectedIndex === 1) { 
            setXmlConfigAction("create"); 
        } 
    }, []);
    const handleChangeTagSeparator = useCallback((newValue) => { 
        if (validateTagSeparator.test(newValue)) { 
            setTagSeparator(newValue); 
            setTagSeparatorValid(true);
        } else { 
            setTagSeparator(newValue);
            setTagSeparatorValid(false);
        } 
    }, []);

    const fileUpload = useMemo(() => 
        !file && <s-text>Click here to upload a file</s-text>
    , [file]);

    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" alignment="center">
                <s-thumbnail
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : <s-icon type="edit" />
                    }
                />
                <s-stack gap="small-100">
                    <s-text>
                        {file.name}
                    </s-text>
                    <s-text>
                        {file.size} bytes
                    </s-text>
                </s-stack>
            </s-stack>
        )
    , [file, validFileTypes]);

    useEffect(() => {
        setSelectedExportFilters(exportFilterOptions.map((option) => option.value));
        getConfigExport();
        setDownloadSpinner(false);
        getProductVariantCount();
        getConfig();
        setFile(null);
        deleteOlderLogs();
        statusPolling();
        checkExportStatus();
        ResumePendingImports(storeUrl);
        loadPlanStatus();
        loadTrialStatus(); // Load trial status on mount
    }, []);
    useEffect(() => {
        if (selectedTabIndex === 1) {
            getAllIntegrationConfigs();
            getSchedulerConfigCounts();
        }
    }, [selectedTabIndex]);
    useEffect(() => {
        if (showUpgradeBanner && showTrialBanner) {
            setShowTrialBanner(false);
        }
    }, [showUpgradeBanner]);
    useEffect(() => {
        if (!eventSource) return;
        eventSource.onmessage = (event) => {
            const data = event.data;
            let parsedMessage = null;
            let eventType = null;
            let messageData = null;
            try {
                parsedMessage = JSON.parse(data);
                eventType = parsedMessage.eventType || parsedMessage.type;
                messageData = parsedMessage.data;
            } catch (e) {
                console.warn("Received non-typed SSE message:", data);
            }
            if (eventType === "validationError") {
                const validationData = messageData || parsedMessage || {};
                const validation = validationData.validation;
                const errorType = validationData.errorType || validationData.message || "Validation Error";
                const errors = validationData.errors || validationData.details || [];
                console.log("Validation error received:", validationData);
                setFile(null);
                setBulkStatus("failed");
                setUploadStatus(false);
                setPollingResult(undefined);
                setUploadBtnLoading(false);
                setIsUploadError(true);
                setErrModalActive(true);
                setUploadErrors({ 
                    validation: validation !== undefined ? validation : false, 
                    errorType: errorType, 
                    errors: errors 
                });
            }
            else if (eventType === "ProductValidation") {
                const { isValid, errors } = messageData || {};
                if (isValid === true) {
                    setUploadBtnLoading(false);
                    setIsUploadError(false);
                    setBulkStatus("processing");
                    setProcessingMsg("calculating items");
                    setFile(null);
                } else {
                    setFile(null);
                    setBulkStatus("failed");
                    setUploadStatus(false);
                    setPollingResult(undefined);
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setErrModalActive(true);
                    setUploadErrors({ validation: false, errors: errors || [] });
                }
            }
            else if (eventType === "ProcessingProgress") {
                const { progress, message, status } = messageData || {};
                console.log("Processing progress received:", { progress, message, status });
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("progress");
                setProcessingProgress(progress || 0);
                setUploadBtnLoading(false);
            }
            else if (eventType === "ProductUploadBulk") {
                const { status, progress, message } = messageData || {};
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("uploading");
                setStagedUploadProgress(messageData);
            } 
            else if (eventType === "ProductBackup") {
                console.log("Backup notification received:", messageData);
                const { operation, status, progress, message } = messageData || {};
                setBackupStatus(status);
                setBackupProgress(messageData);
                if (status === 'completed' || status === 'error') {
                    setTimeout(() => {
                        setBackupStatus(null);
                        setBackupProgress(null);
                    }, 5000); // Clear after 5 seconds
                }
            }
            else if (eventType === "processingStarted") {
                const { operationId } = messageData || {};
                console.log("Processing started with operationId:", operationId);
                setCurrentOperationId(operationId);
                setUploadBtnLoading(false);
                setIsUploadError(false);
                setBulkStatus("processing");
                setProcessingMsg("preparing");
            }
            else if (eventType === "bulkOperationCreated") {
                const { operationId, bulkId } = messageData || {};
                console.log("Bulk operation created:", { operationId, bulkId });
            }
            else if (eventType === "operationCanceled") {
                const { operationId, message } = messageData || {};
                console.log("Operation canceled early:", message);
                setBulkCancelStatus("Operation canceled before bulk operation started");
                setBulkStatus("cancelled");
                setCurrentOperationId(null);
                setUploadBtnLoading(false);
                setProcessingMsg("");
            }
            else if (eventType === "bulkOperationCanceled") {
                const { operationId, bulkId, message } = messageData || {};
                console.log("Bulk operation canceled:", message);
                setBulkCancelStatus("Bulk operation canceled in Shopify");
                setBulkStatus("cancelled");
                setCurrentOperationId(null);
            }
            else if (data.includes("validation") && !eventType) {
                console.log("Legacy validation handler");
                const { validation } = JSON.parse(data);
                if (validation === true) {
                    setUploadBtnLoading(false);
                    setIsUploadError(false);
                    setBulkStatus("processing");
                    setProcessingMsg("calculating items");
                    setFile(null);
                } else {
                    setFile(null);
                    setBulkStatus("failed");
                    setUploadStatus(false);
                    setPollingResult(undefined);
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setErrModalActive(true);
                    setUploadErrors(JSON.parse(data));
                }
            }
            else if (data.includes("ProcessingProgress") && !eventType) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status, progress } = jsonObject;
                    console.log("Legacy ProcessingProgress handler:", { status, progress });
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setProcessingMsg("progress");
                    setProcessingProgress(progress || status || 0);
                    setUploadBtnLoading(false);
                }
            }
            else if (data.includes("filterList")) {
            }
            else if (data.includes("filterVendorList")) {
            }
            else if (data.includes("uploading")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("uploading");
                setStagedUploadProgress(JSON.parse(data));
            } else if (data.includes("Product delete")) {
                setPollingResult(undefined);
                setBulkStatus("deleting");
                setUploadStatus(true);
                setProcessingMsg("Product delete");
                setProductDeleteStatus(JSON.parse(data));
            } else if (data.includes("Metafield delete")) {
                setPollingResult(undefined);
                setBulkStatus("deleting");
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Metafield delete");
                setMetaDeleteStatus(JSON.parse(data));
            }
            else if (data.includes("productBackup")) {
                const jsonObject = JSON.parse(data);
                console.log("Backup notification received:", jsonObject);
                setBackupStatus(jsonObject.status);
                setBackupProgress(jsonObject);
                if (jsonObject.status === 'completed' || jsonObject.status === 'error') {
                    setTimeout(() => {
                        setBackupStatus(null);
                        setBackupProgress(null);
                    }, 5000); // Clear after 5 seconds
                }
            }
            else if (data.includes("task-status")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;
                    const { type } = jsonObject;
                    if (type === "metaDelete") {
                        if (status?.toLowerCase() === "completed") {
                            setMetaDeleteResult(null);
                            getLogs();
                        } else if (status?.toLowerCase() === "canceled") {
                        } else if (status?.toLowerCase() === "running") {
                            setMetaDeleteResult(jsonObject);
                        }
                    }
                    else {
                        if (status?.toLowerCase() === "completed") {
                            setProductDeleteResult(null);
                            getLogs();
                        } else if (status?.toLowerCase() === "canceled") {
                        } else if (status?.toLowerCase() === "running") {
                            setProductDeleteResult(jsonObject);
                        }
                    }
                }
            }
            else if (data.includes("bulkId")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;
                    if (status?.toLowerCase() === "completed") {
                        setPollingResult(jsonObject);
                        setBulkStatus(status);
                        setUploadStatus(false);
                        setFile(null); // Reset file state after completion
                        setDropzoneKey(prev => prev + 1); // Force dropzone re-render
                        getLogs();
                    } else if (status?.toLowerCase() === "canceled") {
                        setUploadStatus(false);
                        setBulkStatus(status);
                        setExportBtnLoading(false);
                        setFile(null); // Reset file state after cancellation
                        setDropzoneKey(prev => prev + 1); // Force dropzone re-render
                        getLogs();
                    } else {
                        setUploadStatus(true);
                        setBulkStatus(status);
                        setPollingResult(jsonObject);
                    }
                }
            }
            else if (data.includes("Split products")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Split products");
                setSplitProducts(jsonObject);
            }
            else if (data.includes("Query products")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Query products");
                setQueryProducts(jsonObject);
            }
            else if (data.includes("Split metafields")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Split metafields");
                setSplitProducts(jsonObject);
            }
            else if (data.includes("bulkop")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject.status = "canceled") {
                    setBulkStatus(false);
                    setPollingResult(undefined);
                    setBulkCancelStatus(""); getLogs();
                }
                else {
                    setBulkCancelStatus(jsonObject.status);
                }
            } else if (data === "pong") {
            } else if (data === "downloadComplete") {
                setExportStatus("completed");
                setActive(false);
                setDownloadSpinner(false);
                setExportBtnLoading(false);
                setShowBanner(true);
                getConfigExport();
            }
            else if (data === "downloadCompleteBanner") {
                setActive(false);
                setDownloadSpinner(false);
                setShowBanner(false);
            }
            else if (data.includes("Export")) {
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    getConfigExport();
                }
                try {
                    const jsonObject = JSON.parse(data);
                    if (jsonObject) {
                        const { type, status, completedAt } = jsonObject;
                        if (type.includes("Product") || type.includes("ImageExport") || type.includes("ExportImage")) { setMutationType("product"); setExportResult(jsonObject); }
                        else if (type.includes("Customer")) { setMutationType("customer"); }
                        else if (type.includes("Collection")) { setMutationType("collection"); }
                        if (status?.toLowerCase() === "completed" || status?.toLowerCase() === "failed" || status?.toLowerCase() === "expired") {
                            setDownloadSpinner(false);
                            if (type.includes("Product") || type.includes("Variant")) {
                                setExportStatus(status?.toLowerCase());
                                setExportCompletedAt(completedAt);
                                setExportResult(jsonObject);
                                isExportConfig = false;
                            }
                        }
                        setRootObjectCount(jsonObject.rootObjectCount);
                        setExportNotifyJson(jsonObject);
                        setExportStatus(status?.toLowerCase());
                    }
                } catch (err) {
                    console.warn("Non-JSON message received:", data);
                }
            }
            else if (data.includes("serverException")) {
                setExportBtnLoading(false);
                if (data === "serverException Metafields") {
                    uploadError("metafield");
                }
                else {
                    uploadError("server");
                }
            }
        }
        return () => {
            if (eventSource) {
                eventSource.onmessage = null; // Remove the event handler
            }
        };
    }, [eventSource]);
    useEffect(() => {
        setSelectedIntegration('');
    }, [selectedTabIndex === 0]);
    useEffect(() => {
        if (selectedIntegration !== "" && xmlConfigAction === "refresh") {
            console.log("Refreshing schedulers for integration:", selectedIntegration);
            getSchedulers();
            setXmlConfigAction("Create");
        }
    }, [xmlConfigAction]);
    const getSchedulers = async () => {
        try {
            setSchedulerLoading(true);
            const response = await fetch(`${endpoint}/api/Integrations/config?storeUrl=${storeUrl}&importType=${selectedIntegration}`);
            if (!response.ok) {
                setSchedulerLoading(false);
                throw new Error('Failed to fetch XML config');
            }
            const data = await response.json();
            setExistingXmlConfig(data);
            setSchedulerLoading(false);
        } catch (error) {
            setSchedulerLoading(false);
            console.error('Error fetching XML config:', error);
        } finally {
            setSchedulerLoading(false);
        }
    };
    const getAllIntegrationConfigs = async () => {
        try {
            setSchedulerLoading(true);
            setIntegrationUpgradeNotification(null);
            const response = await fetch(`${endpoint}/api/Integrations/config?storeUrl=${storeUrl}`);
            if (response.status === 403) {
                const errorData = await response.json();
                if (errorData.requiresUpgrade) {
                    setIntegrationUpgradeNotification({
                        message: errorData.message,
                        feature: errorData.feature || 'ScheduleImports'
                    });
                    setExistingXmlConfig([]);
                    setSchedulerLoading(false);
                    return;
                }
            }
            if (!response.ok) {
                throw new Error('Failed to fetch integration configs');
            }
            const allConfigs = await response.json();
            setExistingXmlConfig(allConfigs);
            setSchedulerLoading(false);
        } catch (error) {
            setSchedulerLoading(false);
            console.error('Error fetching integration configs:', error);
            setExistingXmlConfig([]);
        }
    };
    const fetchInitialData = async () => {
        console.log("Fetching initial data for integration:", selectedIntegration);
        fetchShopifyHeaders();
        if (selectedIntegration !== "FTP") {
            setFetchLoading(true);
            try {
                await Promise.all([
                    fetchAndParseFeed(null, integrationConfig.xmlUrl),
                    setOpenMapModal(true)
                ]);
            } catch (err) {
                console.error("Error in fetching initial data:", err);
            } finally {
                setFetchLoading(false);
            }
        }
        else {
            setFetchLoading(true);
            try {
                await Promise.all([
                    fetchShopifyHeaders(),
                    fetchAndParseFeed(ftpConfig, null),
                    setOpenMapModal(true)
                ]);
            } catch (err) {
                console.error("Error in fetching initial data:", err);
            } finally {
                setFetchLoading(false);
            }
        }
    };
    const sanitizeXml = (xmlText) => {
        const firstAngle = xmlText.indexOf("<");
        let cleanXml = xmlText.substring(firstAngle);
        cleanXml = cleanXml.replace(/&(?!amp;|lt;|gt;|quot;|apos;)/g, "&amp;");
        return cleanXml;
    };
   const fetchAndParseFeed = async (ftpConfig, url) => {
  try {
    setXmlFields([]);
    const requestBody = {
      url,
      storeUrl,
      importType: selectedIntegration,
      FTPConfig: selectedIntegration === "FTP" ? ftpConfig : null,
    };
    const response = await fetch(`${endpoint}/api/ProductCustom/integrations`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });
    const contentType = response.headers.get("Content-Type");
    if (selectedIntegration === "XML" || contentType?.includes("xml")) {
      const rawText = await response.text();
      const sanitizedXml = sanitizeXml(rawText);
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(sanitizedXml, "application/xml");
      const collectFieldNames = (node, fieldSet) => {
        const children = Array.from(node.children || []);
        if (children.length > 0) {
          children.forEach((child) => fieldSet.add(child.nodeName));
          children.forEach((child) => collectFieldNames(child, fieldSet));
        }
      };
      const fieldSet = new Set();
      collectFieldNames(xmlDoc.documentElement, fieldSet);
      if (fieldSet.size === 0) {
        console.warn("No fields detected in XML feed.");
        return;
      }
      const fieldNames = Array.from(fieldSet);
      console.log("Detected XML fields:", fieldNames);
      setXmlFields(fieldNames);
    } else {
      const headers = await response.json();
      if (Array.isArray(headers)) {
        console.log("Parsed JSON fields:", headers);
        setXmlFields(headers);
      }
    }
  } catch (err) {
    console.error("Error parsing feed:", err);
  }
};
    const getSchedulerConfigCounts = useCallback(() => {
        fetchScheduleCounts(storeUrl).then(res => {
            if (res) {
                const { XML, FTP, Sheets } = res;
                setSchedulerConfigCounts({ xmlCount: XML, ftpCount: FTP, sheetsCount: Sheets });
            }
        }).catch(error => {
            if (error.response && error.response.status === 403) {
                setSchedulerConfigCounts({ xmlCount: 0, ftpCount: 0, sheetsCount: 0 });
            } else {
                console.error("Error fetching scheduler counts:", error);
            }
        });
    }, [storeUrl]);
    const fetchShopifyHeaders = async () => {
        try {
            const response = await fetch(`${endpoint}/api/ProductCustom/shopify-headers?storeUrl=${storeUrl}`);
            const data = await response.json();
            if (!Array.isArray(data)) {
                console.warn("Expected an array of header strings from backend.");
                return;
            }
            console.log("Shopify Headers:", data);
            const defaultCSVHeaders = ["null"];
            const headersShopify = [...defaultCSVHeaders, ...data];
            setShopifyFields(headersShopify);
        } catch (err) {
            console.error("Error fetching Shopify headers:", err);
        }
    };
    const cancelUpload = useCallback(() => {
        setCSVHeaders([]);
        setFile(null);
        setOpenMapModal(false);
        setUploadBtnLoading(false);
        setBulkStatus("");
        setPollingResult(undefined);
        setUploadStatus(false);
        setExportBtnLoading(false);
        setProcessingMsg();
    }, []);
    const uploadError = (type) => {
        type === "metafield" ? setMetaInfoToast(true) : setUploadErrorToat(true);
        setCSVHeaders([]);
        setFile(null);
        setOpenMapModal(false)
        setUploadBtnLoading(false);
        setBulkStatus("")
        setPollingResult(undefined);
        setUploadStatus(false);
        setExportBtnLoading(false)
        setProcessingMsg()
    };
    const loadPlanStatus = async () => {
        try {
            const planStatus = await getPlanStatus(storeUrl);
            if (planStatus.success) {
                setPlanInfo({
                    hasProPlan: planStatus.hasProPlan,
                    isFreePlan: planStatus.isFreePlan,
                    productCount: planStatus.productCount,
                    productLimit: planStatus.productLimit,
                    features: planStatus.features
                });
            }
        } catch (error) {
            console.error('Error loading plan status:', error);
        }
    };
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };
    const checkTrialAccess = () => {
        if (!trialInfo) return true;
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };
    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };
    const checkPlanFeature = async (featureName) => {
        try {
            const result = await checkFeatureAccess(storeUrl, featureName);
            if (!result.isAllowed) {
                setRestrictedFeature(featureName);
                setUpgradeBannerMessage(result.reason || `This feature requires a Pro plan subscription.`);
                setShowUpgradeBanner(true);
                return false;
            }
            return true;
        } catch (error) {
            console.error(`Error checking feature ${featureName}:`, error);
            return false;
        }
    };
    const handleApiPlanError = (error) => {
        const errorInfo = handlePlanError(error);
        if (errorInfo.needsUpgrade) {
            setRestrictedFeature(errorInfo.feature || '');
            setUpgradeBannerMessage(errorInfo.message);
            setShowUpgradeBanner(true);
        }
        return errorInfo.needsUpgrade;
    };
    const handleUpgradeBannerDismiss = () => {
        setShowUpgradeBanner(false);
        setRestrictedFeature('');
        setUpgradeBannerMessage('');
    };
    const handleUpgradeAction = () => {
        navigate('/plans' + queryString);
    };
    const submitUpload = () => {
        setFile(null);
        setCSVHeaders([]);
        setOpenMapModal(false)
        setUploadStatus(true);
        setPollingResult(undefined);
        setBulkStatus("validating")
        setProcessingMsg("validating");
    }
    const bulkResponseWarningModal = () => {
        const warnings = [];
        console.log("Upload Warnings: bulkResponseWarningModal", uploadWarnings);
        uploadWarnings.forEach(({ x }, index) => {
            warnings.push(
                <s-text key={index}>
                    #{index + 1}&nbsp;{x}
                </s-text>
            );
        });
    };
    const bulkResponseErrorModal = useMemo(() => {
        return (
            <s-modal
                id="bulk-error-modal"
                size="base"
                heading="Failed products"
                padding="none"
            >
                <s-table padding="none">
                    <s-table-header-row>
                        <s-table-header>Sl No</s-table-header>
                        <s-table-header>Handle</s-table-header>
                        <s-table-header>Error</s-table-header>
                    </s-table-header-row>
                    <s-table-body>
                        {bulkErrors?.map(({ handle, userErrors }, index) => (
                            <s-table-row key={index}>
                                <s-table-cell>
                                    <s-text type="strong">{index + 1}</s-text>
                                </s-table-cell>
                                <s-table-cell>
                                    <s-text>{handle}</s-text>
                                </s-table-cell>
                                <s-table-cell>
                                    <s-text tone="critical">
                                        {userErrors?.[0]?.message || 'Unknown error'}
                                    </s-text>
                                </s-table-cell>
                            </s-table-row>
                        ))}
                    </s-table-body>
                </s-table>
                
                <s-button
                    slot="primary-action"
                    commandFor="bulk-error-modal"
                    command="--hide"
                    onClick={handleBulkErrorChangeModal}
                >
                    Close
                </s-button>
            </s-modal>
        );
    }, [bulkErrors, bulkErrorActive, handleBulkErrorChangeModal]);
    const modal = useMemo(() => (
            <s-modal
                id="export-modal"
                heading="Export"
                padding="base"
                onShow={() => getProductFilterList()}
            >
                {isLoading === false ?
                    <s-box padding="none">
                                <s-heading variant="headingSm" fontWeight="semibold">Filters</s-heading>
                                <s-select
                                    label="Vendor"
                                    value={selectedVendor}
                                    onChange={(e) => setSelectedVendor(e.currentTarget.value)}
                                >
                                    {vendors.map((vendor) => (
                                        <s-option key={vendor} value={vendor}>{vendor}</s-option>
                                    ))}
                                </s-select>
                                <s-select
                                    label="Product Type"
                                    value={selectedType}
                                    onChange={(e) => setSelectedType(e.currentTarget.value)}
                                >
                                    {types.map((type) => (
                                        <s-option key={type} value={type}>{type}</s-option>
                                    ))}
                                </s-select>
                            <s-divider />

                                <s-heading >Export Options</s-heading>
                                <s-checkbox
                                    key="selectAll"
                                    label="Select All"
                                    checked={allSelected}
                                    id="selectAll"
                                    name="exportFilter"
                                    onChange={(e) => {
                                        const checked = e?.currentTarget?.checked ?? e?.target?.checked;
                                        handleSelectAllChange(!!checked);
                                    }}
                                />
                                {exportFilterOptions.map(option => (
                                    <s-checkbox
                                        key={option.value}
                                        label={option.label}
                                        checked={selectedExportFilters.includes(option.value)}
                                        id={option.value}
                                        name="exportFilter"
                                        onChange={(e) => {
                                            const checked = e?.currentTarget?.checked ?? e?.target?.checked;
                                            handleExportFilterChange(option.value, !!checked);
                                        }}
                                    />
                                ))}

                            <s-divider />

                            {/* Settings */}
                                <s-heading variant="headingSm" fontWeight="semibold">Settings</s-heading>
                                <s-text-field
                                    label="Tag Separator"
                                    type="text"
                                    value={tagSeparator || ''}
                                    onInput={(e) => handleChangeTagSeparator(e.currentTarget.value)}
                                    error={tagSeparatorValid ? undefined : "Only special characters are allowed."}
                                    help-text="Separate tags to individual columns. Example: '-' or '_'"
                                />
                                <s-choice-list
                                    label="Export format"
                                    name="exportFormat"
                                    values={[checkedExportFormat.toString()]}
                                    onChange={(e) => {
                                        const selectedValues = e.currentTarget.values;
                                        if (selectedValues.length > 0) {
                                            setCheckedExportFormat(parseInt(selectedValues[0]));
                                        }
                                    }}
                                >
                                    <s-choice value="0">CSV</s-choice>
                                    <s-choice value="1">XLSX</s-choice>
                                </s-choice-list>
                    </s-box>
                    : 
                    <s-box padding="large">
                        <s-stack alignItems="center" justifyContent="center">
                            <s-spinner size="large" />
                        </s-stack>
                    </s-box>
                }
                {exportFilterMsg !== null && (
                    <s-box paddingBlockStart="large" padding="large">
                        <s-stack direction="inline" gap="small" alignItems="start">
                            <s-text color="success">{exportFilterMsg}</s-text>
                        </s-stack>
                    </s-box>
                )}
                <s-button
                    slot="primary-action"
                    variant="primary"
                    onClick={() => { exportByFilter(); }}
                    commandFor="export-modal"
                    command="--hide"
                    disabled={!["completed", "", "canceled", "expired", "failed"].includes(exportStatus) || !!uploadStatus || !!blockUpload || isLoading || !tagSeparatorValid}
                    loading={false}
                >
                    Export
                </s-button>
            </s-modal>

    ), [active, handleChangeModal, exportStatus, uploadStatus, blockUpload, isLoading, vendors, selectedVendor, types, selectedType, allSelected, exportFilterOptions, selectedExportFilters, handleExportFilterChange, handleSelectAllChange, exportFilterMsg, tagSeparator, tagSeparatorValid, checkedExportFormat, handleChangeTagSeparator]);
    const next = useCallback(() => {
        const newPageNo = pageNo + 1;
        if (newPageNo <= pageCount) {
            setPageNo(newPageNo);
            setPrvButton(true);
        } else { 
            setNxtButton(false); 
            setPrvButton(true); 
        }
    }, [pageNo, pageCount]);
    const prev = useCallback(() => {
        const newPageNo = pageNo - 1;
        if (newPageNo >= 1) {
            setPageNo(newPageNo);
            setNxtButton(true);
        } else { 
            setPrvButton(false); 
            setNxtButton(true); 
        }
    }, [pageNo]);
    useEffect(() => {
        if (pageNo) {
            getLogs();
        }
    }, [pageNo]);

    useEffect(() => {
            if (exportStatus === "completed" || exportStatus === "failed") {
                getConfigExport();
            }
        }, [exportStatus]);
        
    const generateProductErrorModal = useCallback((errors) => {
        setBulkErrors(errors);
        setBulkErrorActive(true);

        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
            }, 0);
    }, []);
    const generateMetafieldErrorModal = useCallback((errors) => {
        setBulkMetaErrors(errors);
        setBulkMetaErrorActive(true);

        setTimeout(() => {
            const modal = document.getElementById('bulk-meta-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }, []);
    const generateUploadWarningsModal = useCallback((errors) => {
        console.log("Upload Warnings generateUploadWarningsModal", errors);
        setUploadWarnings(errors);
        setUploadWarningsActive(true);
        setUploadWarningsLoading(true);

        setTimeout(() => {
            const modal = document.getElementById('upload-warnings-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
          }, 0);
    }, []);

    var appUpdateBanner = (
        <s-banner heading="Update Required" tone="info">
            Updates are required due to changes in Shopify API. The following scopes are needed:
            <s-unordered-list>
                <s-list-item>read_publications</s-list-item>
                <s-list-item>write_publications</s-list-item>
            </s-unordered-list>
            <s-button
                slot="secondary-actions"
                variant="secondary"
                onClick={() => { redirectToAppUpdate() }}
                loading={appUpdateLoader}
            >
                Update now
            </s-button>
        </s-banner>
    );

    var metaDeleteNotification = (
        <>
            {metaDeleteResult !== undefined && metaDeleteResult !== null ? (
                <s-section background="surface" border="base" borderRadius="large">
                    <s-box padding="large">
                        <s-stack gap="base">
                            <s-stack direction="inline" alignment="center" gap="large" wrap={false}>
                                <s-stack direction="inline" gap="small" alignment="center">
                                    <s-icon
                                        source="alert-circle"
                                        tone={metaDeleteResult.status === "failed" ? "critical" : "subdued"}
                                    />
                                    <s-badge
                                        tone={metaDeleteResult.status === "failed" ? "critical" : "info"}
                                    >
                                        {metaDeleteResult.status}
                                    </s-badge>
                                    <s-text type="strong">
                                        Metafield delete
                                    </s-text>
                                </s-stack>
                                <s-text>
                                    Pending: <s-text type="strong">{metaDeleteResult.pending}</s-text>
                                </s-text>
                            </s-stack>
                        </s-stack>
                    </s-box>
                </s-section>
            ) : null}
        </>
    );
    var productDeleteNotification = (
        <>
            {productDeleteResult !== undefined && productDeleteResult !== null ? (
                <s-section background="surface" border="base" borderRadius="large">
                    <s-box padding="large">
                        <s-stack gap="base">
                            <s-stack direction="inline" alignment="center" gap="large" wrap={false}>
                                <s-stack direction="inline" gap="small" alignment="center">
                                    <s-icon
                                        source="alert-circle"
                                        tone={productDeleteResult.status === "failed" ? "critical" : "subdued"}
                                    />
                                    <s-badge
                                        tone={productDeleteResult.status === "failed" ? "critical" : "info"}
                                    >
                                    {productDeleteResult.status}
                                </s-badge>
                                <s-text type="strong">
                                    Product delete
                                </s-text>
                            </s-stack>
                            <s-text>
                                Pending: <s-text type="strong">{productDeleteResult.pending}</s-text>
                            </s-text>
                        </s-stack>
                    </s-stack>
                </s-box>
                </s-section>
            ) : null}
        </>
    );
    const CatalogProductsUI = (
        <>
            
            {appUpdate ? appUpdateBanner : null}
            <s-stack gap="base">
                <s-section padding="base">
                    <s-box padding="none">
                        <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                            <s-grid-item gridColumn="span 6">
                            <s-stack gap="small">
                                    <s-stack gap="small-100">
                                        <s-heading>Upload File</s-heading>
                                        <s-link onClick={() => openSampleFile()}>
                                            Download a sample file
                                        </s-link>
                                        <s-drop-zone
                                            key={dropzoneKey}
                                            multiple={false}
                                            accept=".csv,.xlsx"
                                            onInput={(event) => {
                                                const files = event.currentTarget.files;
                                                if (files && files.length > 0) {
                                                    handleDropZoneDrop([], Array.from(files), []);
                                                }
                                            }}
                                        >
                                            {uploadedFile}
                                            {fileUpload}
                                        </s-drop-zone>
                                        <s-text color="subdued">
                                            Accepts .csv/.xlsx format. Maximum size: 20 MB
                                        </s-text>
                                    </s-stack>
                                    <s-stack gap="small-100">
                                        <s-heading>Settings</s-heading>
                                        <s-text-field
                                            label="Conversion price"
                                            value={conversionPrice || '0'}
                                            onInput={(e) => setConversionPrice(e.currentTarget.value)}
                                            details="Multiply Price and Compare at Price by this value. Set 0 to keep original prices. Example: INR to USD = 0.012"
                                        />
                                        <s-checkbox
                                            label="Image Proxy"
                                            checked={imageProxy}
                                            onChange={(e) => setImageProxy(e.currentTarget.checked)}
                                            details="Upload images via our CDN for reliable uploads to Shopify"
                                        />
                                        <s-stack direction="inline" gap="small">
                                            <s-button
                                                variant="primary"
                                                disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                                loading={uploadBtnLoading}
                                                onClick={() => FileUploadValidation()}
                                            >
                                                Upload
                                            </s-button>
                                            <s-button variant="secondary" commandFor="presets-modal" command="--show">
                                                Edit templates
                                            </s-button>
                                        </s-stack>
                                    </s-stack>
                                </s-stack>
                            </s-grid-item>
                            <s-grid-item gridColumn="span 6">
                                {/* Note Section with Image Watermark */}
                                <div style={{ position: 'relative' }}>
                                    {/* Watermark Image Background */}
                                    <div 
                                        style={{
                                            position: 'absolute',
                                            bottom: '-230px',
                                            right: '10px',
                                            width: '500px',
                                            height: '500px',
                                            backgroundImage: `url(${WatermarkImage})`,
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'bottom right',
                                            opacity: '0.15',
                                            pointerEvents: 'none',
                                            zIndex: 0
                                        }}
                                    />
                                    
                                    {/* Note Content - On top of watermark */}
                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                        <s-stack gap="small-100">
                                            <s-heading>Note</s-heading>
                                            <s-unordered-list>
                                                <s-list-item>
                                                    After you upload the file, you will be greeted by a mapping tool to select the columns from your file to match a field in Shopify.
                                                </s-list-item>
                                                <s-list-item>
                                                    The mapping tool auto detects a few columns already to save time.
                                                </s-list-item>
                                                <s-list-item>
                                                    To speed up uploads, reduce columns you don't need by removing them (click the red - button on the right)
                                                </s-list-item>
                                                <s-list-item>
                                                    To delete:
                                                </s-list-item>
                                            </s-unordered-list>
                                            <s-box paddingInlineStart="base">
                                                <s-unordered-list>
                                                    <s-list-item color="subdued">
                                                        Products - Append the value of the <s-text type="strong">Title</s-text> with <s-text type="strong">/delete</s-text>
                                                    </s-list-item>
                                                    <s-list-item color="subdued">
                                                        Variants - Append the value of the <s-text type="strong">Variant SKU</s-text> with <s-text type="strong">/delete</s-text>
                                                    </s-list-item>
                                                    <s-list-item color="subdued">
                                                        Metafields - Append the value of the <s-text type="strong">metafield</s-text> with <s-text type="strong">/delete</s-text>
                                                    </s-list-item>
                                                </s-unordered-list>
                                            </s-box>
                                            <s-unordered-list>
                                                <s-list-item>
                                                    Image urls can be comma(,) separated in the first row of the product.
                                                </s-list-item>
                                        <s-list-item>
                                            Image urls from Google Drive and Dropbox share links are automatically updated by us to be accepted in the Shopify
                                        </s-list-item>
                                            </s-unordered-list>
                                    </s-stack>
                                </div>
                            </div>
                            </s-grid-item>
                        </s-grid>
                    </s-box>
                </s-section>
            </s-stack>
            {metaDeleteNotification}
            {productDeleteNotification}
            <ImportProcessing
                bulkStatus={bulkStatus}
                uploadStatus={uploadStatus}
                pollingResult={pollingResult}
                setErrModalActive={setErrModalActive}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                stagedUploadProgress={stagedUploadProgress}
                splitItems={splitProducts}
                productsQuery={queryProducts}
                productDeleteStatus={productDeleteStatus}
                metaDeleteStatus={metaDeleteStatus}
                bulkCancelStatus={bulkCancelStatus}
                cancelBulk={cancelBulk}
                generateProductErrorModal={generateProductErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
                generateUploadWarningsModal={generateUploadWarningsModal}
                mapping={mappingSSE}
                fileParse={fileParse}
                processingProgress={processingProgress}
                backupStatus={backupStatus}
                backupProgress={backupProgress}
            />
            {(exportResult !== undefined && exportConfig !== null ) || (exportStatus === "running" && (!uploadStatus || !!blockUpload)) ?
                // <>
                //     {bulkStatus.toLocaleLowerCase() === "completed" || bulkStatus.toLocaleLowerCase() === "failed" ? <br /> : null}
                    <ExportStatusCard 
                    exportResult={exportResult} 
                    productProgress={rootObjectCount === undefined ? 0 : productCount !== 0 ? ((rootObjectCount / productCount) * 100) : 0} exportConfig={exportConfig} currentRoute="product" />
                // </> 
                : null}

            <s-box paddingBlockStart="base">
                <s-section padding="none">
                    <ImportHistory
                        logs={logs}
                        generateProductErrorModal={generateProductErrorModal}
                        generateMetafieldErrorModal={generateMetafieldErrorModal}
                        generateUploadWarningsModal={generateUploadWarningsModal}
                        downloadResult={downloadResult}
                        loadingMap={loadingMap}
                        logsLoading={logsLoading}
                        hasPreviousPage={prvButton}
                        hasNextPage={nxtButton}
                        onPreviousPage={() => prev()}
                        onNextPage={() => next()}
                    />
                </s-section>
            </s-box>
            {errorModal({ bulkErrorActive, handleBulkErrorChangeModal, bulkErrors, currentRoute: 'product' })}
            {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })}
            {WarningModal({ uploadWarningsActive, handleUploadWarningsChangeModal, uploadWarnings })}
            <ValidationErrorModal
                errModalActive={isUploadError && errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            />
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} error={false} />
            <ToastMarkup toast={uploadErrorToat} toggleToast={toggleUploadErrorToast} content={"Server error"} error={true} />
            <ToastMarkup toast={metaInfoToast} toggleToast={toggleMetaInfoToast} content={"No metafield to update"} error={false} />
        </>
    );
    const presets = useMemo(() => (
        <Presets connectionType={"File"} activate={openPresetModal} setActivate={setOpenPresetModal} />
    ), [openPresetModal]);
    const openDeleteModal = useCallback((config) => {
        console.log("openDeleteModal called with config:", config);
        setSelectedConfig(config);
        setDeleteModalActive(true);
        
        // Debug: Check if modal element exists
        setTimeout(() => {
            const modal = document.getElementById('delete-modal');
            console.log("Modal element found:", modal);
            if (modal) {
                console.log("Calling modal.showOverlay()");
                modal.showOverlay?.();
            }
        }, 100);
    }, []);
    const handleDeleteSchedulerConfig = useCallback(async (jobId) => {
        console.log("handleDeleteSchedulerConfig called with jobId:", jobId);
        console.log("selectedConfig:", selectedConfig);
        
        try {
            // Make direct API call to delete the configuration
            const response = await fetch(
                `${endpoint}/api/Integrations/config-delete?storeUrl=${storeUrl}&jobId=${jobId}`,
                {
                    method: 'DELETE',
                }
            );

            if (!response.ok) {
                throw new Error('Failed to delete configuration');
            }

            console.log("Configuration deleted successfully");
            
            // Close modal and reset state
            setDeleteModalActive(false);
            setSelectedConfig(null);
            
            // Refresh the configuration lists
            setTimeout(() => {
                console.log("Refreshing config lists after delete");
                getAllIntegrationConfigs();
                getSchedulerConfigCounts();
            }, 500);
            
        } catch (error) {
            console.error("Error deleting configuration:", error);
            // TODO: Show error message to user
        }
    }, [selectedConfig, storeUrl]);
    const schedulerConfigHistory = (
        <>
            <s-table>
                <s-table-header-row>
                    <s-table-header>Job Name</s-table-header>
                    <s-table-header>Cron Expression</s-table-header>
                    <s-table-header>Last Run</s-table-header>
                    <s-table-header>Next Run</s-table-header>
                    <s-table-header>Created At</s-table-header>
                    <s-table-header>Actions</s-table-header>
                </s-table-header-row>
                <s-table-body>
                {existingXmlConfig && existingXmlConfig.length > 0 ? existingXmlConfig.map((config, index) => {
                    const { feedUrl, jobName, cronExpression, lastRun, nextRun, createdAt, ftpConfig, importFormat } = config;
                    let integrationType = 'XML';
                    if (importFormat === 1 || importFormat === 'XML') {
                        integrationType = 'XML';
                    } else if (importFormat === 2 || importFormat === 'FTP') {
                        integrationType = 'FTP';
                    } else if (importFormat === 3 || importFormat === 'Sheets') {
                        integrationType = 'Sheets';
                    }
                    return (
                        <s-table-row key={String(config.jobId)}>
                            <s-table-cell>
                                <s-text>
                                    {jobName}
                                </s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text>
                                    {cronExpression}
                                </s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-badge tone='success'>
                                    <s-text>
                                        {getTimeDifferenceText(lastRun)}
                                    </s-text>
                                </s-badge>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text>
                                    {getTimeDifferenceText(nextRun)}
                                </s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text>
                                    {getTimeDifferenceText(createdAt)}
                                </s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-stack direction="inline" gap="small">
                                    <s-button onClick={() => { setSelectedIntegration(integrationType); setXmlConfigAction('edit'); setJobId(config.jobId); setSchedulerSelectedTab(0); }} variant='plain' tone='success' icon="edit"></s-button>
                                    <s-button commandFor="delete-modal" onClick={() => { console.log("Delete button clicked"); openDeleteModal(config); }} variant='plain' tone='critical' icon="delete"> </s-button>
                                </s-stack>
                            </s-table-cell>
                        </s-table-row>
                    )
                }) : (
                    <s-table-row>
                        <s-table-cell colSpan={6}>
                            <s-box padding="large">
                                <s-stack alignment="center">
                                    <s-text tone="subdued">No scheduled imports configured</s-text>
                                </s-stack>
                            </s-box>
                        </s-table-cell>
                    </s-table-row>
                )}
                </s-table-body>
            </s-table>
        </>
    );
    const integrationOptions = [
        {
            id: 'XML',
            title: 'XML Feed',
            description: 'Using an XML URL',
            icon: XmlIcon,
            badge: schedulerConfigCounts.xmlCount,
        },
        {
            id: 'Sheets',
            title: 'Google Sheets',
            description: 'Via the shared link',
            icon: SheetsIcon,
            badge: schedulerConfigCounts.sheetsCount,
        },
        {
            id: 'FTP',
            title: 'FTP',
            description: 'Retrieve from FTP server',
            icon: ftpIcon,
            badge: schedulerConfigCounts.ftpCount,
        },
    ];
    const getIntegrationIcon = (integrationType) => {
        switch (integrationType) {
            case 'XML':
                return XmlIcon;
            case 'Sheets':
                return SheetsIcon;
            case 'FTP':
                return ftpIcon;
            default:
                return '';
        }
    };
    const getIntegrationTitle = (integrationType) => {
        switch (integrationType) {
            case 'XML':
                return 'XML Feed';
            case 'Sheets':
                return 'Google Sheets';
            case 'FTP':
                return 'FTP';
            default:
                return integrationType;
        }
    };
    const handleCreateIntegrationSelect = useCallback((integrationType) => {
        setCreateIntegrationPopover(false);
        setSelectedIntegration(integrationType);
        setXmlConfigAction('createExpand'); // This will trigger the connection component's modal
        setJobId(null);
    }, []);
    const handleCloseIntegrationModal = useCallback(() => {
        setSelectedIntegration('');
        setXmlConfigAction('');
        setJobId(null);
        setXMLUrl('');
        setCompletedSteps({ step1: false, step2: false });
        setIntegrationConfig({
            jobName: '',
            cronExpression: '00 00 * * *',
            xmlUrl: '',
            ftpConfig: null,
            templateId: null,
            timeZone: timezoneOptions[0]?.value || 'UTC',
            ImportFormat: ''
        });
        setFtpConfig({
            name: '',
            host: '',
            username: '',
            password: '',
            filePath: '',
            isSuccess: false
        });
        setSelectedTemplateId("0");
        getAllIntegrationConfigs();
    }, []);
    const navigateToIntegrationsPricing = useCallback(() => {
        const pricingUrl = '/plans' + queryString;
        window.top.location.href = window.location.origin + pricingUrl;
    }, [queryString]);
    const integrationNextPage = useCallback(() => {
        const newPageNo = integrationPageNo + 1;
        if (newPageNo <= integrationPageCount) {
            setIntegrationPageNo(newPageNo);
            setIntegrationPrvButton(true);
        } else { 
            setIntegrationNxtButton(false); 
            setIntegrationPrvButton(true); 
        }
    }, [integrationPageNo, integrationPageCount]);
    const integrationPrevPage = useCallback(() => {
        const newPageNo = integrationPageNo - 1;
        if (newPageNo >= 1) {
            setIntegrationPageNo(newPageNo);
            setIntegrationNxtButton(true);
        } else { 
            setIntegrationPrvButton(false); 
            setIntegrationNxtButton(true); 
        }
    }, [integrationPageNo]);
    const integrationTabs = (
        <s-section padding="none">
                {integrationUpgradeNotification ? (
                    <s-banner tone="warning">
                            <s-box textAlign="center">
                                <s-heading>
                                    Upgrade to Pro Plan Required
                                </s-heading>
                            </s-box>
                                <s-text color="subdued">
                                    {integrationUpgradeNotification.message}
                                </s-text>
                            <s-divider />
                            <s-stack gap="small">
                                    <s-heading>
                                        Scheduled Integrations features include:
                                    </s-heading>
                                <s-unordered-list>
                                    <s-list-item>Automated XML Feed imports on your schedule</s-list-item>
                                    <s-list-item>Google Sheets integration with scheduled sync</s-list-item>
                                    <s-list-item>FTP server imports with automatic file processing</s-list-item>
                                    <s-list-item>Custom cron schedules for flexible automation</s-list-item>
                                    <s-list-item>Set it and forget it — hands-free product updates</s-list-item>
                                </s-unordered-list>
                            </s-stack>

                            <s-divider />

                                <s-button slot="secondary-actions" variant="secondary-actions" onClick={navigateToIntegrationsPricing}>
                                    View Pricing Plans
                                </s-button>
                    </s-banner>
                ) : (
                    <>
                     <s-box padding="base">
                    <s-grid gridTemplateColumns="1fr auto" gap="base">
                       
                        <s-grid-item>
                            <s-heading>Integration Configurations</s-heading>
                        </s-grid-item>
                        
                        <s-grid-item>
                            <s-button commandFor="create-integration-menu" variant="primary">
                                Create New
                            </s-button>
                            

                            <s-menu id="create-integration-menu" accessibilityLabel="Integration actions">
                                <s-button 
                                    onClick={() => handleCreateIntegrationSelect('XML')}
                                >
                                    <s-stack direction="inline" gap="small" alignment="center">
                                        <img src={XmlIcon} alt="XML" width={20} height={20} />
                                        <s-text>XML Feed</s-text>
                                    </s-stack>
                                </s-button>
                                <s-button 
                                    onClick={() => handleCreateIntegrationSelect('Sheets')}
                                >
                                    <s-stack direction="inline" gap="small" alignment="center">
                                        <img src={SheetsIcon} alt="Sheets" width={20} height={20} />
                                        <s-text>Google Sheets</s-text>
                                    </s-stack>
                                </s-button>
                                <s-button 
                                    onClick={() => handleCreateIntegrationSelect('FTP')}
                                >
                                    <s-stack direction="inline" gap="small" alignment="center">
                                        <img src={ftpIcon} alt="FTP" width={20} height={20} />
                                        <s-text>FTP</s-text>
                                    </s-stack>
                                </s-button>
                            </s-menu>
                        </s-grid-item>
                        
                    </s-grid>
                    </s-box>
                        {/* {schedulerLoading ? (
                                <s-box padding="large">
                                    <s-stack alignItems="center" justifyContent="center">
                                        <s-spinner  size="large" />
                                    
                                    </s-stack>
                                </s-box>
                        ) : ( */}
                            <s-table
                                paginate={existingXmlConfig && existingXmlConfig.length > 0}
                                hasPreviousPage={integrationPrvButton}
                                hasNextPage={integrationNxtButton}
                                onPreviousPage={integrationPrevPage}
                                onNextPage={integrationNextPage}
                                loading={schedulerLoading}
                            >
                                <s-table-header-row>
                                    <s-table-header>Integration Type</s-table-header>
                                    <s-table-header>Job Name</s-table-header>
                                    <s-table-header>Cron Expression</s-table-header>
                                    <s-table-header>Last Run</s-table-header>
                                    <s-table-header>Next Run</s-table-header>
                                    <s-table-header>Created At</s-table-header>
                                    <s-table-header>Actions</s-table-header>
                                </s-table-header-row>
                                <s-table-body>
                                    {schedulerLoading ? (
                                        <s-table-row>
                                            <s-table-cell></s-table-cell>
                                            <s-table-cell></s-table-cell>
                                            <s-table-cell></s-table-cell>
                                            <s-table-cell>
                                                <s-stack alignItems="center" gap="base" padding="large">
                                                    <s-spinner accessibilityLabel="Loading integration configurations" size="large" />
                                                </s-stack>
                                            </s-table-cell>
                                        </s-table-row>
                                    ) : existingXmlConfig && existingXmlConfig.length > 0 ? (
                                        existingXmlConfig.map((config, index) => {
                                            const { feedUrl, jobName, cronExpression, lastRun, nextRun, createdAt, ftpConfig, importFormat } = config;
                                            let integrationType = 'XML';
                                            if (importFormat === 1 || importFormat === 'XML') {
                                                integrationType = 'XML';
                                            } else if (importFormat === 2 || importFormat === 'FTP') {
                                                integrationType = 'FTP';
                                            } else if (importFormat === 3 || importFormat === 'Sheets') {
                                                integrationType = 'Sheets';
                                            }
                                            return (
                                                <s-table-row key={String(config.jobId)}>
                                                    <s-table-cell>
                                                        <s-stack direction="inline" gap="base" blockAlignment="center">
                                                            <img 
                                                                src={getIntegrationIcon(integrationType)} 
                                                                alt={integrationType} 
                                                                width={24} 
                                                                height={24}
                                                            />
                                                            <s-text type="strong">
                                                                {getIntegrationTitle(integrationType)}
                                                            </s-text>
                                                        </s-stack>
                                                    </s-table-cell>
                                                    <s-table-cell>
                                                        <s-text>
                                                            {jobName}
                                                        </s-text>
                                                    </s-table-cell>
                                                    <s-table-cell>
                                                        <s-text>
                                                            {cronExpression}
                                                        </s-text>
                                                    </s-table-cell>
                                                    <s-table-cell>
                                                        <s-badge tone='success'>
                                                            <s-text>
                                                                {getTimeDifferenceText(lastRun)}
                                                            </s-text>
                                                        </s-badge>
                                                    </s-table-cell>
                                                    <s-table-cell>
                                                        <s-text>
                                                            {getTimeDifferenceText(nextRun)}
                                                        </s-text>
                                                    </s-table-cell>
                                                    <s-table-cell>
                                                        <s-text>
                                                            {getTimeDifferenceText(createdAt)}
                                                        </s-text>
                                                    </s-table-cell>
                                                    <s-table-cell>
                                                        <s-stack direction="inline" gap="small">
                                                            <s-button 
                                                                onClick={() => { 
                                                                    setSelectedIntegration(integrationType);
                                                                    setXmlConfigAction('editExpand'); 
                                                                    setJobId(config.jobId); 
                                                                    setSchedulerSelectedTab(0);
                                                                }} 
                                                                variant='tertiary' 
                                                                tone='success' 
                                                                icon="edit"
                                                            />
                                                            <s-button 
                                                                commandFor="delete-modal"
                                                                onClick={() => { 
                                                                    console.log("Delete button clicked"); 
                                                                    openDeleteModal(config); 
                                                                }} 
                                                                variant='tertiary' 
                                                                tone='critical' 
                                                                icon="delete"
                                                            />
                                                        </s-stack>
                                                    </s-table-cell>
                                                </s-table-row>
                                            )
                                        })
                                    ) : (
                                        <s-table-row>
                                            <s-table-cell colSpan={7}>
                                                <s-box padding="xx-large">
                                                    <s-stack gap="large" alignment="center">
                                                        <s-text tone="subdued">
                                                            No integration configurations found
                                                        </s-text>
                                                        <s-text tone="subdued">
                                                            Create your first integration to get started
                                                        </s-text>
                                                    </s-stack>
                                                </s-box>
                                            </s-table-cell>
                                        </s-table-row>
                                    )}
                                </s-table-body>
                            </s-table>
                        {/* )} */}
                
                    </>
                )}
        </s-section>
    );
    console.log("mapping activation=", xmlFields.length, selectedIntegration, shopifyFields.length);
    const mappingHtml = (
        <>
            {xmlFields.length > 0 && selectedIntegration !== '' && shopifyFields.length > 0 && (
                <CSVMapping cancelUpload={cancelUpload} uploadError={uploadError} submitUpload={submitUpload} csvHeaders={xmlFields} incomingShopifyHeaders={shopifyFields} activate={openMapModal} file={XMLUrl} storeUrl={storeUrl} dbTagSeparator={tagSeparator} currentRoute={"preset"} uploadType={selectedIntegration} ftpConfig={ftpConfig} setSelectedTemplateId={setSelectedTemplateId} setCompletedSteps={setCompletedSteps}></CSVMapping>
            )}
        </>
    );
    const schedulerHtml = (
        <s-stack direction="inline" alignment="trailing">
            <s-stack direction="inline" gap="none">
                <s-button
                    variant={enableScheduler ? 'primary' : 'secondary'}
                    onClick={() => setEnableScheduler(!enableScheduler)}
                >
                    {enableScheduler ? 'Automate' : 'Automate'}
                </s-button>
            </s-stack>
        </s-stack>
    );
    const schedulerConfig = (
        <>
            {selectedSchedulerTab === 0 && (
                <>
                    <s-stack gap="base">
                        <s-text variant="heading-sm">Configure Schedule</s-text>
                        <s-text variant="body-sm" type="subdued">
                            If you want to run this feed on a schedule, provide a cron expression.
                        </s-text>
                    </s-stack>
                    <CronSchedulerConfig xmlUrl={XMLUrl} setUrlError={setUrlError} storeUrl={storeUrl} setExistingXmlConfig={setExistingXmlConfig} action={xmlConfigAction} setXmlConfigAction={setXmlConfigAction} jobId={jobId} setJobId={setJobId} importType={selectedIntegration} ftpConfig={ftpConfig} setFtpConfig={setFtpConfig} setSchedulerSelectedTab={setSchedulerSelectedTab} integrationConfig={integrationConfig} setIntegrationConfig={setIntegrationConfig} setCompletedSteps={setCompletedSteps} />
                </>
            )}
            </>
    );
    const importHistory = (
        <>
            <ImportHistory
                logs={logs}
                generateProductErrorModal={generateProductErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
                generateUploadWarningsModal={generateUploadWarningsModal}
                downloadResult={downloadResult}
                loadingMap={loadingMap}
                logsLoading={logsLoading}
            />
            <s-stack direction="inline" gap="base">
                <s-icon type="home" />
                <s-icon type="order" />
                <s-icon type="product" />
                <s-icon type="settings" />
            </s-stack>
            {errorModal({ bulkErrorActive, handleBulkErrorChangeModal, bulkErrors, currentRoute: 'product' })}
            {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })}
            {WarningModal({ uploadWarningsActive, handleUploadWarningsChangeModal, uploadWarnings })}
        </>
    );
    const xmlComponent = (
        <>
            {integrationTabs}
            <XMLConnection
                mappingHtml={mappingHtml}
                schedulerConfig={schedulerConfig}
                schedulerConfigHistory={schedulerConfigHistory}
                action={selectedIntegration === 'XML' ? xmlConfigAction : ''}
                selectedIntegration={selectedIntegration}
                setXmlConfigAction={setXmlConfigAction}
                jobId={jobId}
                setJobId={setJobId}
                templateId={selectedTemplateId}
                integrationConfig={integrationConfig}
                setIntegrationConfig={setIntegrationConfig}
                setCompletedSteps={setCompletedSteps}
                completed={completedSteps}
                fetchMappingData={fetchInitialData}
                xmlFields={xmlFields}
                shopifyFields={shopifyFields}
                refreshConfigList={getAllIntegrationConfigs}
                onModalClose={handleCloseIntegrationModal}
            />
            <SheetsConnection
                mappingHtml={mappingHtml}
                schedulerConfig={schedulerConfig}
                schedulerConfigHistory={schedulerConfigHistory}
                action={selectedIntegration === 'Sheets' ? xmlConfigAction : ''}
                selectedIntegration={selectedIntegration}
                setXmlConfigAction={setXmlConfigAction}
                jobId={jobId}
                setJobId={setJobId}
                templateId={selectedTemplateId}
                integrationConfig={integrationConfig}
                setIntegrationConfig={setIntegrationConfig}
                setCompletedSteps={setCompletedSteps}
                completed={completedSteps}
                fetchMappingData={fetchInitialData}
                sheetFields={xmlFields}
                shopifyFields={shopifyFields}
                refreshConfigList={getAllIntegrationConfigs}
                onModalClose={handleCloseIntegrationModal}
            />
            <FTPConnection 
                ftpConfig={ftpConfig} 
                setFtpConfig={setFtpConfig} 
                savedConfigs={savedConfigs} 
                setSavedConfigs={setSavedConfigs} 
                mappingHtml={mappingHtml} 
                importHistory={importHistory} 
                schedulerConfig={schedulerConfig} 
                schedulerConfigHistory={schedulerConfigHistory} 
                completedSteps={completedSteps} 
                action={selectedIntegration === 'FTP' ? xmlConfigAction : ''}
                selectedIntegration={selectedIntegration}
                setXmlConfigAction={setXmlConfigAction} 
                jobId={jobId}
                setJobId={setJobId} 
                templateId={selectedTemplateId} 
                integrationConfig={integrationConfig}
                setIntegrationConfig={setIntegrationConfig}
                setCompletedSteps={setCompletedSteps} 
                completed={completedSteps} 
                fetchMappingData={fetchInitialData} 
                ftpFields={xmlFields} 
                shopifyFields={shopifyFields}
                refreshConfigList={getAllIntegrationConfigs}
                onModalClose={handleCloseIntegrationModal}
            />
            {(uploadStatus || bulkStatus) && (
                <>
                    {metaDeleteNotification}
                    {productDeleteNotification}
                    <ImportProcessing
                        bulkStatus={bulkStatus}
                        uploadStatus={uploadStatus}
                        pollingResult={pollingResult}
                        setErrModalActive={setErrModalActive}
                        processingMsg={processingMsg}
                        catalogExtractMsg={catalogExtractMsg}
                        stagedUploadProgress={stagedUploadProgress}
                        splitItems={splitProducts}
                        productsQuery={queryProducts}
                        productDeleteStatus={productDeleteStatus}
                        metaDeleteStatus={metaDeleteStatus}
                        bulkCancelStatus={bulkCancelStatus}
                        cancelBulk={cancelBulk}
                        generateProductErrorModal={generateProductErrorModal}
                        generateMetafieldErrorModal={generateMetafieldErrorModal}
                        mapping={mappingSSE}
                        fileParse={fileParse}
                        processingProgress={processingProgress}
                        backupStatus={backupStatus}
                        backupProgress={backupProgress}
                    />
                </>
            )}
            {modal}
            {bulkErrors?.length > 0 ? bulkResponseErrorModal : null}
            <ValidationErrorModal
                errModalActive={isUploadError && errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            />
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} error={false} />
            <ToastMarkup toast={uploadErrorToat} toggleToast={toggleUploadErrorToast} content={"Server error"} error={true} />
            <ToastMarkup toast={metaInfoToast} toggleToast={toggleMetaInfoToast} content={"No metafield to update"} error={false} />
        </>
    );
    const backupComponent = (
        <BackupsList storeUrl={storeUrl} eventSource={eventSource}/>
    );
    
    return (
        <s-page heading='Products'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            
            {/* Tab-like buttons in secondary actions with custom styling */}
            <s-button 
                slot="secondary-actions"
                disabled = {selectedTabIndex === 0}
                onClick={() => setSelectedTabIndex(0)}
            >
                Import
            </s-button>
            <s-button 
                slot="secondary-actions"
                disabled = {selectedTabIndex === 1}
                variant="primary"
                onClick={() => setSelectedTabIndex(1)}
            >
                Integrations
            </s-button>
            <s-button 
                slot="secondary-actions"
                disabled = {selectedTabIndex === 2}
                variant="primary"
                onClick={() => setSelectedTabIndex(2)}
            >
                Backups
            </s-button>
            
            <s-button slot="primary-action"
                disabled={!["completed", "", "canceled", "expired", "failed"].includes(exportStatus) || !!uploadStatus || !!blockUpload}
                commandFor="export-modal"
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus === "failed" || exportStatus === "canceled" ? exportStatus : `${exportStatus}.  This may take a few moments.`}`}
                        </span>
                    </s-tooltip>
                ) : (
                    "Export"
                )}
            </s-button>
            {}
            <UpgradeBanner
                show={showUpgradeBanner}
                message={upgradeBannerMessage}
                feature={restrictedFeature}
                onDismiss={handleUpgradeBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />
            {}
            
            {presets}
            {modal}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />
            
            {/* Conditional rendering based on selected tab */}
            {selectedTabIndex === 0 && CatalogProductsUI}
            {selectedTabIndex === 1 && xmlComponent}
            {selectedTabIndex === 2 && backupComponent}
            
         {csvHeaders.length > 0 && selectedIntegration === '' ? <CSVMapping cancelUpload={cancelUpload} uploadError={uploadError} submitUpload={submitUpload} csvHeaders={csvHeaders} incomingShopifyHeaders={incomingShopifyHeaders} activate={openMapModal} file={file} storeUrl={storeUrl} dbTagSeparator={tagSeparator} currentRoute={"product"} uploadType={"File"} ftpConfig={ftpConfig} setSelectedTemplateId={setSelectedTemplateId}></CSVMapping> : null}
            
            {/* Delete Scheduler Config Modal */}
            <DeleteModal
                active={deleteModalActive}
                setActive={(v) => { setDeleteModalActive(v); if (!v) setSelectedConfig(null); }}
                handleDelete={() => handleDeleteSchedulerConfig(selectedConfig?.jobId)}
                itemName={selectedConfig?.jobName || 'item'}
            />
        </s-page>
    );
    function openSampleFile() {
        window.open(environment.productSampleFile, '_blank');
    }
    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setUploadErrorToat(true);
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setUploadErrorToat(true);
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }
    async function cancelBulk(bulkId) {
        bulkCancel(storeUrl, bulkId, currentOperationId).then(function (result) {
            setBulkCancelStatus("canceling");
        });
    }
    async function uploadChunk(chunk, chunkIndex, totalChunks) {
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);
        const response = await fetch(endpoint + '/api/productCustom/file-validation-chunk', {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) {
            throw new Error('Chunk upload failed');
        }
    }
    async function FileUploadValidation() {
        var config = {
            conversionPrice: conversionPrice === null || conversionPrice === undefined ? 0 : conversionPrice,
            cdnUpload: imageProxy,
            tagSeparator: tagSeparator,
            exportFormat: checkedExportFormat
        };
        try {
            await AddStoreConfig(config, storeUrl);
        } catch (error) {
            console.log("Config save error:", error);
        }
        const canImport = await checkPlanFeature('BulkOperations');
        if (!canImport) {
            return;
        }
        if (planInfo.isFreePlan && planInfo.productCount >= planInfo.productLimit) {
            setRestrictedFeature('UnlimitedProducts');
            setUpgradeBannerMessage(`You have reached the ${planInfo.productLimit} product limit for the free plan. Upgrade to Pro for unlimited products.`);
            setShowUpgradeBanner(true);
            return;
        }
        if (file !== null) {
            setBulkCancelStatus("");
            setIsUploadError(false);
            setUploadErrors(false);
            setBulkErrors([]);
            setUploadBtnLoading(true);
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            let allChunksUploaded = true;
            try {
                for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                    const start = chunkIndex * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, file.size);
                    const chunk = file.slice(start, end);
                    try {
                        await uploadChunk(chunk, chunkIndex, totalChunks);
                    } catch (error) {
                        console.log("error=", error);
                        allChunksUploaded = false;
                        setUploadBtnLoading(false);
                        setIsUploadError(true);
                        setUploadErrors({
                            errorType: "exception",
                            errors: ["File upload failed. Please try again."]
                        });
                        setErrModalActive(true);
                        break;
                    }
                }
                if (allChunksUploaded) {
                    const formData = new FormData();
                    formData.append('fileName', file.name);
                    formData.append('totalChunks', totalChunks);
                    formData.append('storeUrl', storeUrl);
                    fetch(endpoint + '/api/productCustom/file-validation-combine', {
                        method: 'POST',
                        body: formData,
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(data => {
                            const defaultCSVHeaders = ["null"];
                            const fileHeaders = [...defaultCSVHeaders, ...data?.fileHeaders];
                            setCSVHeaders(fileHeaders);
                            const headersShopify = [...defaultCSVHeaders, ...data?.shopifyHeaders];
                            setShopifyHeaders(headersShopify);
                            setOpenMapModal(true);
                            setUploadBtnLoading(false);
                        })
                        .catch(error => {
                            setUploadBtnLoading(false);
                            setIsUploadError(true);
                            setUploadErrors({
                                errorType: "exception",
                                errors: ["Failed to process file headers. Please check your file format."]
                            });
                            setErrModalActive(true);
                        });
                }
            } catch (error) {
                setUploadBtnLoading(false);
                setIsUploadError(true);
                setUploadErrors({
                    errorType: "exception",
                    errors: ["An error occurred while uploading the file. Please try again."]
                });
                setErrModalActive(true);
            }
        }
    }
    function deleteOlderLogs() {
        DeleteLogs(storeUrl).then(function (result) {
        });
    }
    function getProductVariantCount() {
        checkProductVariantCount(storeUrl, false).then(function (result) {
            setProductCount(result.productCount);
        })
    }
    function getProductFilterList() {
        setIsLoading(true);
        setSelectedVendor("All");
        setSelectedType("All");
        filterProductList(storeUrl, false)
            .then(function (result) {
                const vendorsWithDefault = ['All', ...result.vendors];
                setVendors(vendorsWithDefault);
                const typesWithDefault = ['All', ...result.types];
                setTypes(typesWithDefault);
            })
            .catch(function (error) {
                setVendors(['All']);
                setTypes(['All']);
            })
            .finally(function () {
                setIsLoading(false);
            });
    }
    function getProductSavedSearches() {
        setIsLoading(true);
        productSavedSearches(storeUrl)
            .then(function (result) {
                if (result.length > 0) {
                    var defaultValue = {
                        name: "Select an option",
                        id: null
                    };
                    const searchesWithDefault = [defaultValue, ...result];
                    setSavedSearches(searchesWithDefault);
                    setSelectedSearch(null);
                } else {
                    setSavedSearches([defaultValue]);
                    setSelectedSearch(null);
                }
            })
            .catch(function (error) {
                const defaultValue = {
                    name: "Select an option",
                    id: null
                };
                setSavedSearches([defaultValue]);
                setSelectedSearch(null);
            })
            .finally(function () {
                setIsLoading(false);
            });
    }
    function getProductFilterListRefresh() {
        setIsLoading(true);
        filterProductList(storeUrl, true).then(function (result) {
            const vendorsWithDefault = ['All', ...result.vendors];
            setVendors(vendorsWithDefault);
            const typesWithDefault = ['All', ...result.types];
            setTypes(typesWithDefault);
            setIsLoading(false);
        })
    }
    async function exportByFilter() {
        var config = {
            tagSeparator: tagSeparator,
            exportFormat: checkedExportFormat
        };
        try {
            await AddStoreConfig(config, storeUrl);
            setToast(true);
        } catch (error) {
            console.log("Config save error:", error);
        }
        const canExport = await checkPlanFeature('AdvancedImportExport');
        if (!canExport) {
            handleChangeModal(); // Close the export modal
            return;
        }
        setShowBanner(false);
        setExportFilterMsg(null);
        if (selectedVendor !== "All" || selectedType !== "All" || selectedSearch !== null) {
            var formatType = 0;
            getStoreConfig(storeUrl).then(function (result) {
                if (result !== null) {
                    formatType = result?.exportFormat;
                }
                setExportBtnLoading(true);
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: allSelected ? JSON.stringify(["Fullexport"]) : JSON.stringify(selectedExportFilters)
                };
                const encodedSelectedSearch = encodeURIComponent(selectedSearch);
                const encodedSelectedType = encodeURIComponent(selectedType);
                const url = `${endpoint}/api/Product/export-filter?storeUrl=${storeUrl}&vendor=${selectedVendor}&type=${encodedSelectedType}&searchId=${encodedSelectedSearch}`;
                fetch(url, requestOptions)
                    .then(response => {
                        if (response.status === 200 && response !== null) {
                            return response.blob().then((blob) => {
                                if (blob && blob.size > 0) {
                                    var format = formatType === 0 ? ".csv" : ".xlsx"
                                    const fileName = "products" + "_" + storeUrl + "_" + new Date().toLocaleString() + "" + format;
                                    saveAs(blob, fileName);
                                    setExportBtnLoading(false);
                                    setExportFilterMsg(null);
                                } else {
                                    setExportBtnLoading(false);
                                }
                            });
                        }
                        else if (response === null) {
                            setExportBtnLoading(false);
                        }
                        else if (response.status === 400) {
                            setExportBtnLoading(false);
                            return response.statusText
                        }
                    })
                    .catch(error => {
                        setExportBtnLoading(false);
                        return []
                    })
            });
        }
        else {
            setExportBtnLoading(false);
            exportAllProducts();
        }
    }
    function exportAllProducts() {
        setExportStatus('running');
        setExportBtnLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: allSelected ? JSON.stringify(["Fullexport"]) : JSON.stringify(selectedExportFilters)
        };
        fetch(endpoint + '/api/Product/export-products-new?storeUrl=' + storeUrl, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                    setExportBtnLoading(false);
                }
                else if (response.status === 400) {
                    setExportBtnLoading(false);
                    return response.statusText
                }
            })
            .catch(error => {
                setExportBtnLoading(false);
                return []
            })
    }
    function statusPolling() {
        bulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                if (status?.toLowerCase() === "completed") {
                    setPollingResult(undefined);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status?.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    function checkExportStatus() {
        productExpportStatus(storeUrl).then(function (result) {
            setDownloadSpinner(true);
            if (result !== null) {
                var status = result?.status?.toLowerCase();
                var type = result.type
                if (status === "completed" && (type === "product" || type?.toLowerCase() === "products" || type === "variant")) {
                    setMutationType(type);
                    setExportStatus(status)
                    setRootObjectCount(result.rootObjectCount);
                    setExportCompletedAt(result.completedAt);
                    setExportResult(result);
                }
                else if ((type === "product" || type?.toLowerCase() === "products" || type === "variant") && status === "running") {
                    setMutationType(type);
                    setExportStatus(status)
                    setRootObjectCount(result.rootObjectCount);
                    setDownloadSpinner(true);
                    setExportResult(result);
                }
                else if ((type === "product" || type?.toLowerCase() === "products" || type === "variant") && status === "processing") {
                    setMutationType(type);
                    setExportStatus(status)
                    setDownloadSpinner(true);
                    setExportResult(result);
                }
                else if (status === "failed" && (type === "product" || type?.toLowerCase() === "products" || type === "variant")) {
                    setMutationType(type);
                    setExportStatus("failed")
                    setDownloadSpinner(false);
                    setExportResult(result);
                }
                else if (status === "failed" && type === "customer") {
                    setExportStatus("completed")
                    setDownloadSpinner(false);
                    setExportResult(result);
                }
                else if (type !== "product" || type?.toLowerCase() === "products" && type !== "variant" && status === "running") {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                }
                else {
                    getConfigExport()
                    setDownloadSpinner(false);
                }
            }
        })
    }
    function getLogs() {
        setLogsLoading(true);
        // Backend returns all logs (File, XML, FTP, Sheets) regardless of importFormat parameter
        getProductImportHistory(storeUrl, pageNo, PAGE_SIZE, "File").then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount(Math.ceil(result.totalCount / PAGE_SIZE));
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }
    function checkPrevExport() {
        checkPrevExportExist(storeUrl, "ProductCustom").then(function (result) {
            if (result !== null) {
                if (result.exists) {
                    setExportCompletedAt(result.lastModified);
                    setExportStatus("completed");
                }
                else {
                    setExportStatus("");
                    setMutationType("product");
                }
            }
        });
    }
    function getConfig() {
        getStoreConfig(storeUrl).then(function (result) {
            if (result !== null) {
                setTagSeparator(result?.tagSeparator);
                setConversionPrice(result?.conversionPrice);
                setImageProxy(result?.cdnUpload);
                setCheckedExportFormat(result?.exportFormat);
            }
        });
    }
    function redirectToAppUpdate() {
        setAppUpdateLoader(true);
        MainAuthUrl(storeUrl)
            .then(res => {
                window.open(res, '_top');
            }, err => {
            });
    }
    function getConfigExport() {
        getExportConfig(storeUrl, "product").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
            }
        });
    }
}
